import get from 'lodash/get';
import mapValues from 'lodash/mapValues';

import PropTypes from 'prop-types';
import cn from 'classnames';
import React, { Component } from 'react';
import css from './css.css';
import { WithVariadicFilterRow } from './VariadicFilterRow';
import { WithVariadicRangeField } from './VariadicRangeField';

import { BoolField, DateField, SelectField, TextField, TimeField, YesNoSelect, WysiwygField } from '~/native-ui';

import identify from '~/identify';
import FileField from '~/ui/Fields/FileField/FileField';
import ElementTooltipContainer from '~/ui/Tooltip/ElementTooltipContainer';
import { connectedField } from './connectedField';

let generalFieldMapping = {
    text: { field: TextField },
    select: { field: SelectField },
    select_many: { field: SelectField, props: { multiSelect: true } },
    textarea: { field: TextField, props: { multiline: true } },
    // wysiwyg: { field: TextField, props: { multiline: true } },
    wysiwyg: { field: WysiwygField },
    bool: { field: BoolField },
    belongs_to: { field: SelectField },
    belongs_to_many: { field: SelectField, props: { multiSelect: true } },
    date: { field: DateField, props: { floating: true } },
    datetime: { field: DateField, props: { mask: '11.11.1111 11:11', floating: true } },
    time: { field: TimeField, props: { mask: '11:11', floating: true } },
    file: { field: FileField },
    image: { field: FileField },
};

let fieldMapping = {
    [identify.FILTERFIELD]: {
        ...mapValues(generalFieldMapping, (object) => ({
            ...object,
            field: WithVariadicFilterRow(object.field),
            rangeEnabled: false,
        })),
        textarea: { field: WithVariadicFilterRow(TextField), rangeEnabled: false },
        wysiwyg: { field: WithVariadicFilterRow(TextField), rangeEnabled: false },
        bool: { field: WithVariadicFilterRow(YesNoSelect), rangeEnabled: false },
        create: { field: WithVariadicFilterRow((props) => null), rangeEnabled: false },
    },
    [identify.EDITFIELD]: {
        ...generalFieldMapping,
        // datetime: { field: DateField, props: { fieldType: 'date', floating: true  } },
    },
};

let getComponentType = (inputType, type) => {
    return get(fieldMapping, `${inputType}.${type}`, fieldMapping[inputType]?.text);
};

export const VariadicField = (() => {
    class VariadicField extends Component {
        static propTypes = {
            type: PropTypes.string.isRequired,
        };

        onSubmitEditing = () => {
            const { value, filterType } = this.props.value;
            this.props.onSubmitEditing?.(value, filterType);
        };

        renderField = (valueKey = null, props = {}) => {
            let componentData = getComponentType(this.props.inputType, this.props.type),
                FieldComponent = componentData.field,
                rangeEnabled = componentData.rangeEnabled ?? true,
                { value, onChange, isVariadicFilter, ...passedProps } = this.props;

            let fieldProps = {
                ref: this.props.forwardedRef,
                title: this.props.title,
                ...passedProps,
                ...value,
                ...props,
                ...componentData.props,
                isRange: this.props.isRange,
                trans: this.props.trans,
                onChange,
                isVariadicFilter,
                onSubmitEditing: this.props.onSubmitEditing && this.onSubmitEditing,
            };

            if (rangeEnabled && this.props.isRange) {
                FieldComponent = WithVariadicRangeField(FieldComponent);
            }

            return <FieldComponent {...fieldProps} className={cn(fieldProps.className, css.variadicField)} />;
        };

        renderWithoutTooltip() {
            return this.renderField();
        }

        render() {
            let tooltip = this.props.tooltip;

            return tooltip && tooltip.length ? (
                <ElementTooltipContainer leftMargin tooltip={this.props.tooltip}>
                    {this.renderWithoutTooltip()}
                </ElementTooltipContainer>
            ) : (
                this.renderWithoutTooltip()
            );
        }
    }

    return React.forwardRef((props, ref) => <VariadicField forwardedRef={ref} {...props} />);
})();

export const Field = connectedField(VariadicField);

export const Filter = React.forwardRef(({ modelId, name, onChange, ...filterProps }, ref) => {
    return (
        <Field
            isVariadicFilter
            modelId={modelId}
            name={name}
            onChange={onChange}
            inputType={identify.FILTERFIELD}
            ref={ref}
            {...filterProps}
        />
    );
});

export const EditField = ({ modelId, name, onChange, view, ...otherFieldProps }) => {
    return (
        <Field
            modelId={modelId}
            name={name}
            view={view}
            onChange={onChange}
            inputType={identify.EDITFIELD}
            {...otherFieldProps}
        />
    );
};
